import React, {useRef} from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";
import { withRouter } from "react-router-dom";

import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

import {setLookIntroStep, setLookOpened, setSidebarModalOpened} from "../../../../actions/lookFunctions";
import {ROUTES} from "../../../../routes";
import LookIntroPopper from "../lookIntro/lookIntroPopper";
import LookSideBarModal from "./lookSidebarModals/lookSideBarModal";
import {LOOK_INTRO_STEPS} from "../../core/constants";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";

const LookSideBarMoreButton = (props) => {

  const {intl, lookOpened, setLookOpened, setSidebarModalOpened, sidebarModalOpened, history, disabled, isMobile,
    introStep, setLookIntroStep, sidebarButtonClicked} = props;
  const anchorRef = useRef(null);

  const sidebarMoreClick = () => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookSidebarMore);
    if (introStep === LOOK_INTRO_STEPS.saveAndMore) {
      setLookIntroStep();
      return false;
    }
    if (lookOpened) {
      setLookOpened(null);
      history.push(ROUTES.home);
    }
    setSidebarModalOpened(!sidebarModalOpened);
    sidebarButtonClicked();
  }

  const realDisabled = disabled || ((introStep !== LOOK_INTRO_STEPS.welcome) && (introStep !== LOOK_INTRO_STEPS.saveAndMore));

  return (
    <li className="look-sidebar__list-item">
      <Tooltip title={intl.formatMessage({id:"tooltip.resetLook"})} placement="right">
        <IconButton aria-label={intl.formatMessage({id:"tooltip.resetLook"})}
                    ref={anchorRef}
                    disabled={realDisabled}
                    aria-describedby={"sidebar-modal"}
                    className={"look-icon look-sidebar__button" + (sidebarModalOpened ? " look-icon--active" : "")
                      + (introStep === LOOK_INTRO_STEPS.saveAndMore ? " look-sidebar__button--intro" : "")}
                    onClick={sidebarMoreClick}>
          <MoreHorizIcon />
        </IconButton>
      </Tooltip>
      {/*<span className="look-tooltip"><FormattedMessage id="tooltip.home"/></span>*/}
      <LookIntroPopper anchorRef={anchorRef}
                       currentStep={LOOK_INTRO_STEPS.saveAndMore}
                       className="look-step--share"
                       toolTipText={isMobile
                         ? `look.intro.${LOOK_INTRO_STEPS.saveAndMore}.mobile.share.tooltip`
                         : `look.intro.${LOOK_INTRO_STEPS.saveAndMore}.share.tooltip`}/>
      <LookSideBarModal anchorEl={anchorRef}/>
    </li>
  )
};

const mapStateToProps = (store) => {
  const {lookOpened, introStep, sidebarModalOpened} = store.lookState;
  const {isMobile} = store.serverState;
  return {
    lookOpened,
    introStep,
    sidebarModalOpened,
    isMobile,
  };
};

const mapDispatchToProps = {
  setLookOpened,
  setSidebarModalOpened,
  setLookIntroStep,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(LookSideBarMoreButton)
  )
)
